import React from 'react';
import { Keystatic } from '@keystatic/core/ui';
import keystaticConfig from '../keystatic.config.js';

export default function KeystaticApp() {
  return <Keystatic config={keystaticConfig} />;
}